import "leaflet/dist/leaflet";
import "leaflet/dist/leaflet.css";

import * as L from "leaflet";

import { GestureHandling } from "leaflet-gesture-handling";
import "leaflet-gesture-handling/dist/leaflet-gesture-handling.css";
import "leaflet.heat/dist/leaflet-heat";
import "leaflet.markercluster/dist/MarkerCluster.Default.css";
import "leaflet.markercluster/dist/MarkerCluster.css";

import "@geoman-io/leaflet-geoman-free";
import "@geoman-io/leaflet-geoman-free/dist/leaflet-geoman.css";

import "leaflet.markercluster/dist/leaflet.markercluster";
// L.Icon.Default.imagePath = '.';

//@ts-ignore
delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

L.Map.addInitHook("addHandler", "gestureHandling", GestureHandling);

const style = document.createElement("style");

style.textContent = `
    .leaflet-control, .leaflet-top, .leaflet-bottom {
      z-index: 3!important;
    }
    .leaflet-pane{
      z-index: 2!important;
    }
  `;

//@ts-ignore
window.leafletTiles = [
  "https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png",
];
